import { useEval } from '@/context/EvalContext';


const ICON_MAP: Record<string, string> = {
  structure:   'ri-node-tree',
  interaction: 'ri-question-answer-line',
  closure:     'ri-refresh-line',
  priority:    'ri-bar-chart-box-line',
};

export default function AICommentPanel() {
  const evalData = useEval();
  if (!evalData) return null;
  const { totalScore, indicators } = evalData.courseEvalData.aiComment;
  return (
    <div className="h-full flex flex-col" style={{ padding: '4px 8px 6px' }}>
      {/* 标题 + 总分 */}
      <div className="flex items-center justify-between px-1 mb-3 flex-shrink-0">
        <div className="flex items-center gap-2">
          <div className="w-1 h-4 rounded-full flex-shrink-0"
            style={{ background: 'linear-gradient(to bottom, #22d3ee, rgba(34,211,238,0.5))', boxShadow: '0 0 10px rgba(34,211,238,0.9)' }} />
          <span className="text-white font-bold font-semibold tracking-wide" style={{ fontSize: '22px' }}>AI总体点评</span>
        </div>
        <div className="flex items-center gap-1.5 px-2.5 py-0.5 rounded-full"
          style={{ background: 'rgba(34,211,238,0.1)', border: '1px solid rgba(34,211,238,0.32)' }}>
          <span style={{ fontSize: '17px', color: 'white' }}>总分</span>
          <span style={{ fontSize: '17px', fontWeight: 900, color: '#22d3ee', textShadow: '0 0 10px rgba(34,211,238,0.8)' }}>
            {totalScore.toFixed(1)}
          </span>
        </div>
      </div>

      {/* 4个指标 2x2 网格 — 占满剩余高度 */}
      <div className="flex-1 min-h-0 grid grid-cols-2 gap-2.5">
        {indicators.map(item => {
          const isGood = item.status === 'good';
          return (
            <div key={item.id} className="flex flex-col gap-2 rounded-xl p-3"
              style={{
                background: isGood
                  ? 'linear-gradient(145deg, rgba(16,185,129,0.12), rgba(16,185,129,0.04))'
                  : 'linear-gradient(145deg, rgba(34,211,238,0.1), rgba(34,211,238,0.03))',
                border: `1px solid ${isGood ? 'rgba(16,185,129,0.3)' : 'rgba(34,211,238,0.22)'}`,
              }}>
              {/* 图标 + 标签 */}
              <div className="flex items-center gap-2">
                <div className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{
                    background: isGood ? 'rgba(16,185,129,0.25)' : 'rgba(34,211,238,0.18)',
                    border: `1px solid ${isGood ? 'rgba(16,185,129,0.5)' : 'rgba(34,211,238,0.35)'}`,
                  }}>
                  <i className={ICON_MAP[item.id] ?? 'ri-star-line'}
                    style={{ fontSize: '17px', color: isGood ? '#10b981' : '#22d3ee' }} />
                </div>
                <span className="font-bold" style={{ fontSize: '16px', color: isGood ? '#34d399' : '#67e8f9' }}>
                  {item.label}
                </span>
              </div>
              {/* 描述 */}
              <p style={{ fontSize: '17px', color: 'white', lineHeight: 1.5, margin: 0 }}>
                {item.value}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
